import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store/index';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () =>
      import(/* webpackChunkName: "Login" */ '../views/Login.vue'),
  },
  {
    path: '/test',
    name: 'Test',
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "Login" */ '../views/Test.vue'),
  },
  {
    path: '/',
    name: 'Home',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
  },
  {
    path: '/leads',
    name: 'Leads',
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "Leads" */ '../views/Leads.vue'),
  },
  {
    path: '/textgen',
    name: 'Text generator',
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "Text" */ '../views/Textgenerator.vue'),
  },
  {
    path: '/henrik',
    name: 'Henrik',
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "Leads" */ '../views/Henrik.vue'),
  },
  {
    path: '/old_leads',
    name: 'Old Leads',
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "Leads" */ '../views/OldLeads.vue'),
  },
  {
    path: '/admin',
    name: 'Admin',
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "Leads" */ '../views/Admin.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  // let auth = store.user.loggedIn;
  const auth = store.state.user.loggedIn;
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!auth) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
